import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=06b1b640&scoped=true"
import script from "./Filter.vue?vue&type=script&lang=ts"
export * from "./Filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1b640",
  null
  
)

export default component.exports